import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { ILists } from '../../interfaces/merchant';
import { TFunction } from 'react-i18next';
import {
	BUSINESS_INFO_FORM_FIELDS,
	BUSINESS_INFO_FORM_FIELDS_NAMES
} from './business-settings-business-information-form';
import { HELPERS_ROUTES } from '../../components/form/form-input-constants';

interface IBusinessInformationInputsProps {
	lists: ILists
	t: TFunction;
}


export const BUSINESS_INFORMATION_INPUTS = ({ t, lists }: IBusinessInformationInputsProps): IFormInputProps[] => [
	{
		key: BUSINESS_INFO_FORM_FIELDS.COMPANY_NAME,
		fieldName: BUSINESS_INFO_FORM_FIELDS.COMPANY_NAME,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_INFO_FORM_FIELDS_NAMES.COMPANY_NAME)}`,
		label: t(BUSINESS_INFO_FORM_FIELDS_NAMES.COMPANY_NAME),
		inputType: InputType.Text,
		required: true,
		autoComplete: 'off'
	},
	{
		key: BUSINESS_INFO_FORM_FIELDS.DESCRIPTOR,
		fieldName: BUSINESS_INFO_FORM_FIELDS.DESCRIPTOR,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_INFO_FORM_FIELDS_NAMES.DESCRIPTOR)}`,
		label: t(BUSINESS_INFO_FORM_FIELDS_NAMES.DESCRIPTOR),
		inputType: InputType.Text,
		required: true,
		autoComplete: 'off'
	},
	{
		key: BUSINESS_INFO_FORM_FIELDS.TAX,
		fieldName: BUSINESS_INFO_FORM_FIELDS.TAX,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_INFO_FORM_FIELDS_NAMES.TAX)}`,
		label: t(BUSINESS_INFO_FORM_FIELDS_NAMES.TAX),
		inputType: InputType.Text,
		required: true,
		autoComplete: 'off'
	},
	{
		key: BUSINESS_INFO_FORM_FIELDS.MCC,
		fieldName: BUSINESS_INFO_FORM_FIELDS.MCC,
		placeholder: t(BUSINESS_INFO_FORM_FIELDS_NAMES.MCC),
		label: t(BUSINESS_INFO_FORM_FIELDS_NAMES.MCC),
		inputType: InputType.Select,
		required: true,
		route: HELPERS_ROUTES.MCC,
		// isTooltip: true,
		dataCy: 'mcc',
		autoComplete: 'off'
	},
	{
		key: BUSINESS_INFO_FORM_FIELDS.WEB_URL,
		fieldName: BUSINESS_INFO_FORM_FIELDS.WEB_URL,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(BUSINESS_INFO_FORM_FIELDS_NAMES.WEB_URL)}`,
		label: t(BUSINESS_INFO_FORM_FIELDS_NAMES.WEB_URL),
		inputType: InputType.Text,
		required: true,
		// isTooltip: true,
		autoComplete: 'off'
	},
	{
		key: BUSINESS_INFO_FORM_FIELDS.PLATFORM,
		fieldName: BUSINESS_INFO_FORM_FIELDS.PLATFORM,
		placeholder: t(BUSINESS_INFO_FORM_FIELDS_NAMES.PLATFORM),
		label: t(BUSINESS_INFO_FORM_FIELDS_NAMES.PLATFORM),
		inputType: InputType.Select,
		required: false,
		data: lists.ecommercePlatforms,
		dataCy: 'platform',
		placement: 'bottomEnd',
		autoComplete: 'off'
	},
];
